module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "inner-banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "articles-box"
  }, [_c('figure', {
    staticClass: "pic articles-pic fitimg mb-0"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": 'https://admin.weddingsung.com/upload/song/' + this.getCategory.image_origin
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h3', {
    staticClass: "title text-primary"
  }, [_vm._v(_vm._s(this.getCategory.title))]), _vm._v(" "), _c('article', {
    staticClass: "article-editor",
    domProps: {
      "innerHTML": _vm._s(this.getCategory.longcontext)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "song-list"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.songLatest), function(song) {
    return _c('div', {
      staticClass: "song-item row"
    }, [_c('div', {
      staticClass: "col-md-4 song-item-name"
    }, [_vm._v(_vm._s(song.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 song-item-author"
    }, [_vm._v(_vm._s(song.author))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-3 col-md-2 col-8 song-item-date"
    }, [_vm._v(_vm._s(song.updated_at.substr(0, 10)))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-1 col-md-2 col-4 text-center song-item-btn"
    }, [_c('a', {
      staticClass: "btn-song-detail",
      attrs: {
        "href": '/songs/' + song.id
      }
    }, [_vm._v("聆聽去")])])])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_c('h3', {
    staticClass: "title title-bg-music"
  }, [_c('span', [_vm._v(_vm._s(this.songQty) + "首" + _vm._s(this.getCategory.title) + "歌曲")])]), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("挑選歌曲")]), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("語文")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chooseLang),
      expression: "chooseLang"
    }],
    staticClass: "custom-select mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chooseLang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("請選擇")]), _vm._v(" "), _vm._l((_vm.lang), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                            " + _vm._s(option.title) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("節奏")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chooseTempo),
      expression: "chooseTempo"
    }],
    staticClass: "custom-select mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chooseTempo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("請選擇")]), _vm._v(" "), _vm._l((_vm.tempo), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                            " + _vm._s(option.title) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "歌曲名稱 / 作者",
      "aria-describedby": "basic-addon1"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "song-list"
  }, [_vm._m(2), _vm._v(" "), _c('paginate', {
    staticClass: "paginate-langs",
    attrs: {
      "name": "languages",
      "list": _vm.songdata,
      "per": 10,
      "tag": "div"
    }
  }, _vm._l((_vm.paginated('languages')), function(songdata) {
    return _c('div', {
      staticClass: "song-item row"
    }, [_c('div', {
      staticClass: "col-md-3 song-item-name"
    }, [_vm._v(_vm._s(songdata.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 song-item-author"
    }, [_vm._v(_vm._s(songdata.author))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-2 col-md-2"
    }, [_vm._v(_vm._s(songdata.favorite))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-3 col-md-2 col-8 song-item-date"
    }, [_vm._v(_vm._s(songdata.created_at.substr(0, 10)))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-1 col-md-2 col-4 text-center song-item-btn"
    }, [_c('a', {
      staticClass: "btn-song-detail",
      attrs: {
        "href": '/songs/' + songdata.id
      }
    }, [_vm._v("聆聽去")])])])
  }), 0), _vm._v(" "), _c('nav', {
    staticClass: "song-pagination",
    attrs: {
      "aria-label": "Page navigation example"
    }
  }, [_c('paginate-links', {
    attrs: {
      "for": "languages",
      "simple": {
        prev: '上一頁',
        next: '下一頁'
      },
      "classes": {
        'ul': ['pagination', 'pagination-sm'],
        'li': 'page-item',
        '.next > a': ['page-link', 'next-link'],
        '.prev > a': ['page-link', 'prev-link', 'another-class'] // multiple classes
      }
    }
  })], 1)], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title title-bg-music"
  }, [_c('span', [_vm._v("最新上刊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "song-item song-mainitem row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("歌曲")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("歌者")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-md-2"
  }, [_vm._v("刊登時間")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-1 col-md-2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "song-item song-mainitem row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("歌曲")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("歌者")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-md-2"
  }, [_vm._v("収藏數")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-md-2"
  }, [_vm._v("刊登時間")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-1 col-md-2"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a59ae80c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Songs.vue
// module id = 172
// module chunks = 1